import React from "react";
import { withRouter } from "react-router-dom";

const LandingPageEntry = props => {
  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
      alignItems: "center",
      width: "120px",
      height: "120px",
      backgroundColor: props.color,
      margin: 4,
      color: "white",
      fontFamily: "arial"
    },
    name: {
      display: "flex",
      fontSize: "80%"
      // alignSelf: "center"
    },
    icon: {
      display: "flex",
      justifyContent: "center",
      fontSize: "40px",
      width: "80%"
    }
  };
  return (
    <div style={styles.container} onClick={props.navigate}>
      <div style={styles.icon}>{props.icon}</div>
      <div style={styles.name}>
        <p>{props.name}</p>
      </div>
    </div>
  );
};

export default withRouter(LandingPageEntry);
